export default "__VITE_ASSET__7a341a94__"